import { PRODUCT_TYPE_CHILD, PRODUCT_TYPE_PRODUCT } from 'Pages/GMS/Products/constants';
import React, { useState, useRef, useLayoutEffect, useCallback, forwardRef, PropsWithChildren, memo, MouseEventHandler } from 'react';
import ReactDOM from 'react-dom';
import { useNavigate } from "react-router";

const DropdownToggle = forwardRef((props: PropsWithChildren<{}>, ref) => {
    return (
        <>{props.children}</>
    )
})
DropdownToggle.displayName = "DropdownToggle"

const DropdownItem = forwardRef((props: PropsWithChildren<{handleClick: MouseEventHandler<HTMLButtonElement>}>, ref) => {
    return (
        <button data-testid="dropdown-index-button-1"
            className={`tw-py-2.5 tw-pl-4 tw-pr-12 hover:tw-bg-surface-hover-strong relative tw-w-full tw-min-w-max tw-text-left`}
            onClick={props.handleClick}
        >{props.children}
        </button>
    )
})
DropdownItem.displayName = "DropdownItem"

/**
 * 
 * @todo reduce complexity
 * @returns 
 */
const DropdownLoyout = ({bgColor, index, options, item, getStickyToColor, children}: any) => {
    const dropdownRef = useRef<HTMLDivElement>(null);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const [showDropdown, setShowDropdown] = useState<boolean>(false)
    const navigate = useNavigate()

    const handleDropdownToggle = () => {
        setShowDropdown((prevShowDropdown) => !prevShowDropdown);
    };

    const handleClickOutside: React.MouseEventHandler<HTMLButtonElement|HTMLDivElement> = useCallback((event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target as HTMLDivElement) &&
            !buttonRef.current?.contains(event.target as HTMLDivElement)
        ) {
            setShowDropdown(false);
        }
    }, [dropdownRef, buttonRef]);

    useLayoutEffect(() => {
        showDropdown ?
        document.addEventListener("mousedown", handleClickOutside as any) :
        document.removeEventListener("mousedown", handleClickOutside as any)
        return () => {
            document.removeEventListener("mousedown", handleClickOutside as any);
        };
    }, [handleClickOutside, showDropdown])

    const Toggle = children.find((child: any) => child.type.displayName === "DropdownToggle")
    
    const portalRoot = document.getElementById('dropdown-portal') as HTMLDivElement; // Element outside of your app root

    if(!portalRoot) { // verify existence of dropdown-portal
        console.error("div named 'dropdown-portal' is defined")
        return <></>
    }
    return (
        <div className={`tw-h-full`} 
        onMouseLeave={() => setShowDropdown(false)}
        >
        
        <button data-testid="dropdown-index-button-2"
        className={`tw-relative tw-h-full tw-shadow-l tw-pl-2 tw-pr-4 tw-py-2 tw-flex tw-space-x-2 tw-items-center tw-w-full ${bgColor}`} 
        ref={buttonRef} 
        onClick={handleDropdownToggle}>
            {Toggle}
        </button>

        {showDropdown &&
            ReactDOM.createPortal(
            <div
                className={`tw-fixed tw-z-[1003]  tw--translate-x-full tw--translate-y-1/2
                    
                `}
                style={{
                    top: (buttonRef.current?.getBoundingClientRect().y ?? 0) + (buttonRef.current?.clientHeight ?? 0) / 2,
                    left: (buttonRef.current?.getBoundingClientRect().x ?? 0),
                }}
                ref={dropdownRef}
                onMouseLeave={() => setShowDropdown(false)}
            >
                <span className="tw-p-2 tw-bg-surface tw-absolute tw-right-0
                    tw-translate-x-1/2 tw-top-1/2 tw--translate-y-1/2
                    tw-rotate-45 tw-border-r tw-border-t tw-border-edge"></span>
                <div
                className={`tw-w-min tw-h-fit tw-bg-surface tw-text-ink tw-shadow-sm tw-rounded tw-border tw-border-edge tw-min-w-[198px]`}
                >
                {
                    // dynamic children gets listed as array inside array reduce is to distributes these children
                    children
                    .reduce((acc: any, child: any) => Array.isArray(child) ? [...acc, ...child] : [...acc, child],[])
                    .map((child: any) => {
                        if(child.type?.displayName !== 'DropdownItem') return <></>
                        return (
                            <>
                                {child}
                            </>
                        )
                    })
                }
                </div>
            </div>,
            portalRoot
            )
            }
        </div>
    );
};

const Dropdown = Object.assign(memo(DropdownLoyout), {
    Toggle: (DropdownToggle),
    Item: (DropdownItem),
})

export default Dropdown